/* eslint-disable quotes */
export default [
  {
    title: {
      it: 'Fonti per le attività culturali',
      en: 'Sources for cultural activities'
    },
    value: 3_947_557.0,
    description: {
      it:
        'Le fonti sono generate dalla gestione del portafoglio e dai contributi dei soci fondatori.',
      en: 'Sources generated by portfolio management and thanks to founders’ endowments.'
    },
    key: 'funds',
    color: '#18C8B5',
    items: [
      {
        id: 0,
        title: {
          it: 'Gestioni finanziarie',
          en: 'Financial management'
        },
        value: 1_109_566.0
      },
      {
        id: 1,
        title: {
          it: 'Proventi da partecipazioni',
          en: 'Income from equity investments'
        },
        value: 472_779.0
      },
      {
        id: 2,
        title: {
          it: 'Contributi ed entrate occasionali',
          en: 'Occasional contributions and income'
        },
        value: 2_177_297.0
      },
      {
        id: 3,
        title: {
          it: 'Valore aggiunto da esercizi precedenti',
          en: 'Value added from previous years'
        },
        value: 635_616.0
      },
      {
        id: 4,
        title: {
          it: 'Fiscalità',
          en: 'Taxation'
        },
        value: -447_701.0
      }
    ]
  },
  {
    title: {
      it: 'Costi di struttura',
      en: 'Overhead costs'
    },
    description: {
      it: 'Sono i costi di funzionamento per la gestione delle attività della Fondazione.',
      en: 'Costs due to the foundation’s management activities.'
    },
    value: -627_438,
    key: 'costs',
    color: '#E95263',
    items: [
      {
        id: 5,
        title: {
          it: 'Spese di funzionamento',
          en: 'Operating expenses'
        },
        value: -497_810
      },
      {
        id: 6,
        title: {
          it: 'Fondo di quiescenza',
          en: 'Pension Fund'
        },
        value: -126_000
      },
      {
        id: 7,
        title: {
          it: 'Ammortamenti',
          en: 'Amortisation'
        },
        value: -3_627
      }
    ]
  },
  {
    title: {
      it: 'Valore aggiunto prodotto',
      en: 'Value added'
    },
    key: 'total',
    value: 3_320_119,
    color: '#7C4EBB',
    items: [
      {
        id: 8,
        title: {
          it: 'Ricerca',
          en: 'Research'
        },
        value: 403_376.0
      },
      {
        id: 9,
        title: {
          it: 'Attività per l’istruzione',
          en: 'Education initiatives'
        },
        value: 1_188_864
      },
      {
        id: 10,
        title: {
          it: 'Azioni di solidarietà sociale',
          en: 'Social solidarity activities'
        },
        value: 436_714
      },
      {
        id: 11,
        title: {
          it: 'Progetti Covid',
          en: 'Covid'
        },
        value: 725_261
      },
      {
        id: 12,
        value: 2_754_215,
        color: '#7C4EBB',
        key: 'total-calculated',
        description: {
          it:
            "Dei 3,3 milioni di euro di valore generato nel 2020, 2,7 milioni sono stati distribuiti nel corso dell'esercizio.",
          en:
            'Of the 3.3 million euros of value generated in 2020, 2.7 million euros were distributed during the year.'
        },
        bold: true,
        title: {
          it: 'V.A. distribuito nell’esercizio',
          en: 'V.A. distributed within the year'
        }
      },
      {
        id: 13,
        value: 565_904.0,
        color: '#7C4EBB',
        key: 'accantonamento',
        description: {
          it: 'A fine 2020 sono stati accantonati per gli anni futuri 0,5 milioni di euro.',
          en: 'At the end of 2020, 0.5 million euros were set aside for future years.'
        },
        title: {
          it: 'V.A. per attività future e avanzo',
          en: 'V.A. for future activities and surplus'
        }
      }
    ]
  }
];
